// Generated by purs version 0.13.8
"use strict";
var Control_Apply = require("../Control.Apply/index.js");
var Control_Category = require("../Control.Category/index.js");
var Data_Bounded = require("../Data.Bounded/index.js");
var Data_Enum = require("../Data.Enum/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_EuclideanRing = require("../Data.EuclideanRing/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Group = require("../Data.Group/index.js");
var Data_Int = require("../Data.Int/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Ordering = require("../Data.Ordering/index.js");
var Data_Ring = require("../Data.Ring/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Semiring = require("../Data.Semiring/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Traversable = require("../Data.Traversable/index.js");
var Data_Typelevel_Num_Sets = require("../Data.Typelevel.Num.Sets/index.js");
var Data_Typelevel_Undefined = require("../Data.Typelevel.Undefined/index.js");
var $$Math = require("../Math/index.js");
var Zn = function (x) {
    return x;
};
var V = function (x) {
    return x;
};
var Real = function (toNumber) {
    this.toNumber = toNumber;
};
var zn = function (dictPos) {
    return function (x) {
        return Zn(Data_EuclideanRing.mod(Data_EuclideanRing.euclideanRingInt)(x)(Data_Typelevel_Num_Sets.toInt(dictPos.Nat0())(Data_Typelevel_Undefined["undefined"])));
    };
};
var vec = function (x) {
    return function (y) {
        return {
            x: x,
            y: y
        };
    };
};
var toNumber = function (dict) {
    return dict.toNumber;
};
var showVector = function (dictShow) {
    return Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "x";
    }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "y";
    }))(Data_Show.showRecordFieldsNil)(dictShow))(dictShow));
};
var semiringZn = function (dictPos) {
    return new Data_Semiring.Semiring(function (v) {
        return function (v1) {
            return zn(dictPos)(v + v1 | 0);
        };
    }, function (v) {
        return function (v1) {
            return zn(dictPos)(v * v1 | 0);
        };
    }, 1, 0);
};
var semiringVector = function (dictSemiring) {
    return Data_Semiring.semiringRecord()(Data_Semiring.semiringRecordCons(new Data_Symbol.IsSymbol(function () {
        return "x";
    }))()(Data_Semiring.semiringRecordCons(new Data_Symbol.IsSymbol(function () {
        return "y";
    }))()(Data_Semiring.semiringRecordNil)(dictSemiring))(dictSemiring));
};
var semigroupzn = function (dictPos) {
    return new Data_Semigroup.Semigroup(Data_Semiring.add(semiringZn(dictPos)));
};
var semigroupVector = function (dictSemigroup) {
    return Data_Semigroup.semigroupRecord()(Data_Semigroup.semigroupRecordCons(new Data_Symbol.IsSymbol(function () {
        return "x";
    }))()(Data_Semigroup.semigroupRecordCons(new Data_Symbol.IsSymbol(function () {
        return "y";
    }))()(Data_Semigroup.semigroupRecordNil)(dictSemigroup))(dictSemigroup));
};
var scale = function (dictRing) {
    return function (c) {
        return function (v) {
            return {
                x: Data_Semiring.mul(dictRing.Semiring0())(v.x)(c),
                y: Data_Semiring.mul(dictRing.Semiring0())(v.y)(c)
            };
        };
    };
};
var ringZn = function (dictPos) {
    return new Data_Ring.Ring(function () {
        return semiringZn(dictPos);
    }, function (v) {
        return function (v1) {
            return zn(dictPos)(v - v1 | 0);
        };
    });
};
var ringVector = function (dictRing) {
    return Data_Ring.ringRecord()(Data_Ring.ringRecordCons(new Data_Symbol.IsSymbol(function () {
        return "x";
    }))()(Data_Ring.ringRecordCons(new Data_Symbol.IsSymbol(function () {
        return "y";
    }))()(Data_Ring.ringRecordNil)(dictRing))(dictRing));
};
var realNumber = new Real(Control_Category.identity(Control_Category.categoryFn));
var realInt = new Real(Data_Int.toNumber);
var norm = function (dictReal) {
    return function (v) {
        return $$Math.sqrt($$Math.pow(toNumber(dictReal)(v.x))(2.0) + $$Math.pow(toNumber(dictReal)(v.y))(2.0));
    };
};
var newtypeVector = new Data_Newtype.Newtype(function (n) {
    return n;
}, V);
var monoidzn = function (dictPos) {
    return new Data_Monoid.Monoid(function () {
        return semigroupzn(dictPos);
    }, Data_Semiring.zero(semiringZn(dictPos)));
};
var monoidVector = function (dictMonoid) {
    return Data_Monoid.monoidRecord()(Data_Monoid.monoidRecordCons(new Data_Symbol.IsSymbol(function () {
        return "x";
    }))(dictMonoid)()(Data_Monoid.monoidRecordCons(new Data_Symbol.IsSymbol(function () {
        return "y";
    }))(dictMonoid)()(Data_Monoid.monoidRecordNil)));
};
var innerProduct = function (dictSemiring) {
    return function (v) {
        return function (v1) {
            return Data_Semiring.add(dictSemiring)(Data_Semiring.mul(dictSemiring)(v.x)(v1.x))(Data_Semiring.mul(dictSemiring)(v.y)(v1.y));
        };
    };
};
var groupzn = function (dictPos) {
    return new Data_Group.Group(function () {
        return monoidzn(dictPos);
    }, Data_Ring.negate(ringZn(dictPos)));
};
var functorVector = new Data_Functor.Functor(function (f) {
    return function (v) {
        return {
            x: f(v.x),
            y: f(v.y)
        };
    };
});
var foldableVector = new Data_Foldable.Foldable(function (dictMonoid) {
    return function (f) {
        return function (v) {
            return Data_Semigroup.append(dictMonoid.Semigroup0())(f(v.x))(f(v.y));
        };
    };
}, function (f) {
    return function (z) {
        return function (v) {
            return f(f(z)(v.x))(v.y);
        };
    };
}, function (f) {
    return function (z) {
        return function (v) {
            return f(v.x)(f(v.y)(z));
        };
    };
});
var traversableVector = new Data_Traversable.Traversable(function () {
    return foldableVector;
}, function () {
    return functorVector;
}, function (dictApplicative) {
    return function (v) {
        return Control_Apply.apply(dictApplicative.Apply0())(Data_Functor.map((dictApplicative.Apply0()).Functor0())(function (x) {
            return function (y) {
                return {
                    x: x,
                    y: y
                };
            };
        })(v.x))(v.y);
    };
}, function (dictApplicative) {
    return function (f) {
        return function (v) {
            return Data_Traversable.sequence(traversableVector)(dictApplicative)(Data_Functor.map(functorVector)(f)(v));
        };
    };
});
var eqzn = function (dictPos) {
    return new Data_Eq.Eq(function (x) {
        return function (y) {
            return x === y;
        };
    });
};
var ordzn = function (dictPos) {
    return new Data_Ord.Ord(function () {
        return eqzn(dictPos);
    }, function (x) {
        return function (y) {
            return Data_Ord.compare(Data_Ord.ordInt)(x)(y);
        };
    });
};
var eqVector = function (dictEq) {
    return new Data_Eq.Eq(function (x) {
        return function (y) {
            return Data_Eq.eq(dictEq)(x.x)(y.x) && Data_Eq.eq(dictEq)(x.y)(y.y);
        };
    });
};
var ordVector = function (dictOrd) {
    return new Data_Ord.Ord(function () {
        return eqVector(dictOrd.Eq0());
    }, function (x) {
        return function (y) {
            var v = Data_Ord.compare(dictOrd)(x.x)(y.x);
            if (v instanceof Data_Ordering.LT) {
                return Data_Ordering.LT.value;
            };
            if (v instanceof Data_Ordering.GT) {
                return Data_Ordering.GT.value;
            };
            return Data_Ord.compare(dictOrd)(x.y)(y.y);
        };
    });
};
var check = function ($$boolean) {
    return function (x) {
        if ($$boolean) {
            return new Data_Maybe.Just(x);
        };
        return Data_Maybe.Nothing.value;
    };
};
var boundedZn = function (dictPos) {
    return new Data_Bounded.Bounded(function () {
        return ordzn(dictPos);
    }, Data_Semiring.zero(semiringZn(dictPos)), Data_Ring.sub(ringZn(dictPos))(Data_Semiring.zero(semiringZn(dictPos)))(Data_Semiring.one(semiringZn(dictPos))));
};
var enumZn = function (dictPos) {
    return new Data_Enum.Enum(function () {
        return ordzn(dictPos);
    }, Data_Enum.defaultPred(Data_Enum.toEnum(boundedEnumZn(dictPos)))(Data_Enum.fromEnum(boundedEnumZn(dictPos))), Data_Enum.defaultSucc(Data_Enum.toEnum(boundedEnumZn(dictPos)))(Data_Enum.fromEnum(boundedEnumZn(dictPos))));
};
var boundedEnumZn = function (dictPos) {
    return new Data_Enum.BoundedEnum(function () {
        return boundedZn(dictPos);
    }, function () {
        return enumZn(dictPos);
    }, Data_Enum.Cardinality(Data_Typelevel_Num_Sets.toInt(dictPos.Nat0())(Data_Typelevel_Undefined["undefined"])), function (v) {
        return v;
    }, function (x) {
        var v = zn(dictPos)(x);
        return check(v === x)(v);
    });
};
module.exports = {
    toNumber: toNumber,
    Real: Real,
    V: V,
    vec: vec,
    norm: norm,
    innerProduct: innerProduct,
    scale: scale,
    check: check,
    Zn: Zn,
    zn: zn,
    realNumber: realNumber,
    realInt: realInt,
    showVector: showVector,
    semigroupVector: semigroupVector,
    monoidVector: monoidVector,
    semiringVector: semiringVector,
    ringVector: ringVector,
    eqVector: eqVector,
    ordVector: ordVector,
    newtypeVector: newtypeVector,
    functorVector: functorVector,
    foldableVector: foldableVector,
    traversableVector: traversableVector,
    eqzn: eqzn,
    ordzn: ordzn,
    enumZn: enumZn,
    boundedEnumZn: boundedEnumZn,
    boundedZn: boundedZn,
    semigroupzn: semigroupzn,
    groupzn: groupzn,
    monoidzn: monoidzn,
    semiringZn: semiringZn,
    ringZn: ringZn
};
